import { AxiosStatic } from "axios";
import { ppq } from "@teamprevent/common";
import { ServerModelWithDateStrings } from "@teamprevent/common/utils";
import { parse } from "date-fns";

export class PpqReportApi {
    private axios: AxiosStatic;

    constructor(ax: AxiosStatic) {
        this.axios = ax;
    }

    public async loadPpqReport(ohCaseId: string, viewReportTaskId: string): Promise<ppq.PpqReportModel> {
        const response = await this.axios.get(`/api/ohcase/${ohCaseId}/ppqReport/${viewReportTaskId}`);
        return this.parseModel(response.data);
    }

    public async view(ohCaseId: string, viewReportTaskId: string) {
        await this.axios.post(`/api/ohcase/${ohCaseId}/ppqReport/${viewReportTaskId}/viewed`);
    }

    private parseModel = (ppqReport: ServerModelWithDateStrings<ppq.PpqReportModel>): ppq.PpqReportModel => ({
        ...ppqReport,
        assessmentDate: new Date(ppqReport.assessmentDate),
        dateOfBirth: parse(ppqReport.dateOfBirth, "yyyy-MM-dd", new Date())
    });
}
